import { ReactNode } from 'react';
import classnames from 'classnames';

interface Props {
  children: ReactNode;
  id?: string;
  onClick?: () => void;
  selected?: boolean;
  disabled?: boolean;
}

const ActionListItem = ({
  children,
  id = undefined,
  onClick,
  selected,
  disabled = false,
}: Props) => {
  const className = classnames({
    relative: true,
    block: true,
    'px-3': true,
    'text-card-link-color': true,
    'bg-card-background-color': true,
    'border-0': true,
    'active:outline-none': true,
    'focus:outline-none': true,
    'font-bold': selected,
    'opacity-60': disabled,
  });

  const testId = ['action', 'list', 'item', id].filter((i) => !!i).join('-');

  return (
    <div className={'flex justify-center items-center'}>
      <button
        data-testid={testId}
        onClick={() => {
          if (!disabled) onClick?.();
        }}
        className={className}
      >
        {children}
      </button>
    </div>
  );
};

export default ActionListItem;
